/**
 * The filter fields of a report request body — the block every report api module wrote out
 * by hand (docs/DUPLICATION_AUDIT.md, B14).
 *
 * Pages pass `filters` with each list already joined to a CSV string
 * (`areas: '1,2'`), so each field is `filters.<key> || ''`, exactly as before.
 * Reports that do not take a field omit it (the Lambda defaults a missing key to '').
 */

/* [request key, filters key] */
const FILTER_FIELDS = [
  ['device_category_filter', 'deviceCategories'],
  ['device_filter', 'devices'],
  ['area_type_filter', 'areaTypes'],
  ['reason_filter', 'reasons'],
  ['user_filter', 'users'],
  ['event_type_filter', 'eventTypes'],
  ['resident_filter', 'residents'],
  ['resident_group_filter', 'residentGroups'],
  ['area_filter', 'areas'],
  ['area_group_filter', 'areaGroups'],
  ['user_group_filter', 'userGroups'],
];

/**
 * @param {object} filters — CSV strings keyed like reportFilters
 * @param {{ omit?: string[] }} [opts] — request keys this report does not send
 * @returns {object} { device_category_filter, device_filter, … }
 */
export function reportFilterFields(filters = {}, { omit = [] } = {}) {
  const out = {};
  FILTER_FIELDS.forEach(([key, from]) => {
    if (!omit.includes(key)) out[key] = filters[from] || '';
  });
  /* Check-in / rounds windows (docs/CHECKIN_WINDOW_FILTER_PLAN.md): sent only by a page
     that passes `windows`, so no other report's request gains the key. */
  if (filters.windows !== undefined && !omit.includes('window_filter')) out.window_filter = filters.windows || '';
  /* Cloud Maintenance problem types (utils/maintenanceConditions.js), the same opt-in rule. */
  if (filters.conditions !== undefined && !omit.includes('condition_filter')) out.condition_filter = filters.conditions || '';
  /* EHR Tasks task types (utils/ehrTaskTypes.js), the same opt-in rule. */
  if (filters.taskTypes !== undefined && !omit.includes('ehr_task_filter')) out.ehr_task_filter = filters.taskTypes || '';
  return out;
}

/** resp_filter_items: [enabled, operator, minutes]; off by default. */
export const responseTimeField = (filters = {}) => filters.responseTime || [false, 'lt', 60];

/** time_window: minutes from midnight, half-open [start, end). [0, 1440] is all day. */
export const timeWindowField = (filters = {}) => filters.timeWindow || [0, 1440];
